import { render, staticRenderFns } from "./Splash.vue?vue&type=template&id=00ee4a4e&scoped=true&"
var script = {}
import style0 from "./Splash.vue?vue&type=style&index=0&id=00ee4a4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ee4a4e",
  null
  
)

export default component.exports